query GetUserSso($userId: ID!) {
    user(id: $userId) {
        id
        sso {
            requiresSsoLogin
            isNutshellManaged
        }
    }
}
